/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetAsPaidModel as DigiworkMaitreDPosDtoOrderSetAsPaidModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/set-as-paid-model';

export interface SetOrderBillAsPayed$Params {
      body?: DigiworkMaitreDPosDtoOrderSetAsPaidModel
}

export function setOrderBillAsPayed(http: HttpClient, rootUrl: string, params?: SetOrderBillAsPayed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setOrderBillAsPayed.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setOrderBillAsPayed.PATH = '/api/wtr/OrderBill/setorderbillaspayed';
